export default __webpack_public_path__ + "7d6b5e5a16bc9152b56d22aebf794338.png";